// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { notification } from "antd";
import { http } from "../../../engine/api/http";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import routes from "../../../engine/routes";
import { sendEmailInvitation } from "../../../engine/api/apiRequest";

const initialState = {
  user: {
    subRoles: [],
    info: {
      firstname: "",
      lastname: "",
      phone: "",
      genre: "male",
    },
    institution: null,
    email: "",
    _id: undefined,
    archived: false,
    status: "active",
  },
  loading: false,
};

export const getUser = createAsyncThunk(
  "user/getUser",
  async (userId, thunkAPI) => {
    const res = await http.get("/users/" + userId);
    return res.data;
  },
);

export const deleteUser = createAsyncThunk(
  "user/deleteUser",
  async (userId, thunkAPI) => {
    const res = await http.delete("/users/" + userId);

    return res.data;
  },
);

export const updateUser = createAsyncThunk(
  "user/update",
  async (payload, thunkAPI, state) => {
    const user = thunkAPI.getState().user.user;
    const { invitation } = payload;

    if (user._id !== undefined) {
      const res = await http.patch("/users/" + user._id, user);
      notification.success({
        message: `Utilisateur Modifié`,
      });
      return res.data;
    } else {
      const res = await http.post("/users/new", user);
      // thunkAPI.dispatch(updateUserOnList(res.data));
      notification.success({
        message: `Utilisateur Créé`,
      });

      invitation ? await sendEmailInvitation(res.data._id) : null;

      return res.data;
    }
  },
);

const userUserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUser: state => {
      return initialState;
    },
    setPropertiesUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
  },
  extraReducers: {
    [getUser.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getUser.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.user = payload;
    },
    [deleteUser.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [deleteUser.fulfilled]: (state, { payload }) => {
      return initialState;
    },
    [updateUser.pending]: (state, { payload }) => {},
    [updateUser.fulfilled]: (state, { payload }) => {
      state.user = payload;
    },
    [getUser.rejected]: state => {
      state.loading = false;
    },
  },
});

export const initInstitutionUserSlice = ({ userId, institutionId }) => {
  const dispatch = useDispatch();

  const { user } = useSelector(state => state.user);
  const navigate = useNavigate();

  const init = () => {
    if (user._id !== userId && userId !== "new") {
      dispatch(getUser(userId));
    }
  };

  const clear = () => {
    dispatch(clearUser());
  };

  useEffect(() => {
    if (user._id !== undefined && userId === "new") {
      // clear();
      navigate(routes.institutions(institutionId).detailUser(user._id).path, {
        replace: true,
      });
    }
  }, [user]);

  useEffect(() => {
    init();

    if (userId === "new" && user._id !== undefined && user._id !== userId) {
      // Reset when go to a new one
      clear();
      navigate(
        routes.institutions(institutionId).newUserInstitution("new").path,
        {
          replace: true,
        },
      );
    }

    return () => {
      // clear();
    };
  }, []);

  return { init, clear };
};

export const { clearUser, setPropertiesUser } = userUserSlice.actions;

export const userReducer = userUserSlice.reducer;
